import React, { useEffect, useState } from 'react'
import Button from '@/components/Button'
import QuizAnswersCard from '@/components/Cards/QuizAnswersCard'
import Container from '@/components/Container'
import Section from '@/components/Section'
import Title from '@/components/Title'

import { usePage } from '@/hooks'
import { IPropsFinish } from '../interfaces'
import { zhekaWithScheme } from '@/images'
import style from '../styles/quiz.module.scss'
import { QUIZ_FINISH_HEADS } from './const'
import HtmlContent from '@/components/HtmlContent'

const QuizFinish = ({
  textCompletion,
  countQuestions,
  title = '',
  userAnswers,
  onQuizStart = () => {}
}: IPropsFinish): React.ReactElement => {
  const page = usePage()
  const { config } = page?.init_state?.global
  const [correctAnswerCount, setCorrectAnswerCount] = useState(0)
  const [finishTitle, setFinishTitle] = useState(QUIZ_FINISH_HEADS[1])

  useEffect(() => {
    let count = 0
    Object.keys(userAnswers).forEach(key => {
      if (userAnswers[key].isAswerCorrect === true) {
        count++
      }
    })
    setCorrectAnswerCount(count)

    const correctPersent = (count * 100) / countQuestions
    if (correctPersent < 40) {
      setFinishTitle(QUIZ_FINISH_HEADS[1])
    } else if (correctPersent > 40 && correctPersent < 70) {
      setFinishTitle(QUIZ_FINISH_HEADS[2])
    } else if (correctPersent > 70) {
      setFinishTitle(QUIZ_FINISH_HEADS[3])
    }
  }, [])

  return (
    <Container>
      <Section>
        <Title type='h2' theme='h4' className={style.finish__title}>
          {title}
        </Title>

        <div className={style.finish_head}>
          <div className={style.finish_content}>
            <span className={style.finish__status}>Правильно</span>

            <div className={style.finish_points}>
              <span className={style.finish__point_current}>
                {correctAnswerCount}
              </span>
              <span className={style.finish__point}>
                {' / '}
                {countQuestions}
              </span>
            </div>

            <p className={style.finish_result__title}>{finishTitle}</p>

            <p className={style.finish_result__text}>
              <HtmlContent content={textCompletion} />
            </p>

            <div className={style.finish_buttons}>
              <Button
                theme='secondary'
                wide
                highlight
                size='large'
                className={style.finish__button}
                onClick={onQuizStart}
              >
                Пройти еще раз
              </Button>

              <Button
                wide
                highlight
                size='large'
                className={style.finish__button}
                href={config.live_like_a_host}
              >
                Закончить викторину
              </Button>
            </div>
          </div>

          <img
            src={zhekaWithScheme}
            width='560px'
            height='560px'
            alt=''
            className={style.finish__image}
          />
        </div>

        <Title type='h3' theme='h4' className={style.answers__title}>
          Ответы
        </Title>

        <ul className={style.answers_list}>
          {Object.keys(userAnswers).map(key => (
            <li key={`answers-list-${key}`} className={style.answers__item}>
              <QuizAnswersCard
                answerNumber={key}
                correctAnswer={userAnswers[key].correctAnswer}
                isAswerCorrect={userAnswers[key].isAswerCorrect}
                question={userAnswers[key].question}
                userAnswer={userAnswers[key].userAnswer}
              />
            </li>
          ))}
        </ul>

        <div className={style.answers_buttons}>
          <Button
            theme='secondary'
            wide
            highlight
            size='large'
            className={style.finish__button}
            onClick={onQuizStart}
          >
            Пройти еще раз
          </Button>

          <Button
            href={config.live_like_a_host}
            wide
            highlight
            size='large'
            className={style.finish__button}
          >
            Закончить викторину
          </Button>
        </div>
      </Section>
    </Container>
  )
}

export default QuizFinish
